var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('select-rates',{attrs:{"bidId":_vm.bidId},on:{"cancel":_vm.cancel,"hide":_vm.hide,"submit":_vm.hide}})}
var staticRenderFns = []

export { render, staticRenderFns }